import { Box, Stack, Typography } from '@mui/material';
import FileButton from '../ui/FileButton';
import DocumentViewer from '../../../../../Components/Ui/DocumentViewer';

export default function M_TRA_BASIC_01(props) {
  const ext = props.getExtensionFromUrl(props.pdfFile);

  const renderViewer = () => {
    if (!props.pdfFile) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          교육 자료가 없습니다.
        </Typography>
      );
    }

    switch (ext) {
      case 'pdf':
      case 'hwp':
        return (
          <DocumentViewer
            renderPreview={props.renderPreview}
            loading={props.loading}
            onDocumentLoadSuccess={props.onDocumentLoadSuccess}
            pageNumber={props.pageNumber}
            pageWidth={props.pageWidth}
            pageViewHeight={props.pageViewHeight}
            setPageViewHeight={props.setPageViewHeight}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        );

      default:
        return (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            미리보기를 지원하지 않는 파일 형식입니다.
          </Typography>
        );
    }
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', mb: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          교육 자료
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          교육 자료를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden', // 스크롤 방지
        }}
      >
        {renderViewer()}
        <FileButton
          onCancel={props.goToPrevPage}
          onClick={() => {
            if (props.pageNumber === props.numPages || !props.pdfFile) {
            } else {
              props.goToNextPage();
            }
          }}
          pageNumber={props.pageNumber}
          numPages={props.numPages}
        />
      </Box>
    </>
  );
}
